import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Form, DatePicker, Row, Col, Radio, Card, Empty, Button } from 'antd';
import { DollarOutlined, ProductOutlined, TrophyOutlined, } from '@ant-design/icons';
import axios from 'axios';
import Img2 from '../image/Nodata.svg';
import * as XLSX from 'xlsx';
import { useParams, useLocation } from "react-router-dom";
import { BASE_URL } from '../../App';
import { Backdrop, CircularProgress, } from '@mui/material';
import { FaIndianRupeeSign } from "react-icons/fa6";

export default function AccordionExpandDefault(props) {
  const { RangePicker } = DatePicker;
  const [realTime, setRealTime] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [unsettledBills, setUnsettledBills] = useState([]);
  const [displayedBills, setDisplayedBills] = useState(); // State for displayed rows
  const [value, setValue] = useState(1);
  const [document, setDocument] = useState(null);
  const Closebalance = realTime && realTime['closing_balance'];
  const advance = realTime && realTime['mpo_advance'];
  //const Outstanding = realTime && realTime['total_advance'];

  const [totalOpenItemsAmount, setTotalOpenItemsAmount] = useState(0);


  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ rundate: [], selecttype: '' });
  //console.log(new Intl.NumberFormat('en-IN').format(Closebalance));
  //console.log(new Intl.NumberFormat('en-IN').format(advance));
  //console.log(new Intl.NumberFormat('en-IN').format(Outstanding));
  console.log(unsettledBills);


  const location = useLocation();
  const { id } = useParams();
  const login_id = localStorage.getItem('USER_ID');
  const dealer_code = localStorage.getItem('USER_ID');
  const dealerType = localStorage.getItem('usertype');
  const styles = `
  .container.form {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row; /* Change flex-direction to row */
  }
  .container label {
    display: flex;
    cursor: pointer;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.375em;
    margin-right: 1em; /* Adjust margin as needed */
  }
  .container label input {
    position: absolute;
    left: -9999px;
  }

  .container label input:checked + span {
    background-color: #414181;
    color: white;
  }

  .container label input:checked + span:before {
    box-shadow: inset 0 0 0 0.4375em #00005c;
  }

  .container label span {
    display: flex;
    align-items: center;
    padding: 0.375em 0.75em 0.375em 0.375em;
    border-radius: 99em;
    transition: 0.25s ease;
    color: #414181;
  }

  .container label span:hover {
    background-color: #d6d6e5;
  }

  .container label span:before {
    display: flex;
    flex-shrink: 0;
    content: "";
    background-color: #fff;
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    margin-right: 0.375em;
    transition: 0.25s ease;
    box-shadow: inset 0 0 0 0.125em #00005c;
  }
`;

  useEffect(() => {
    const fetchData = async () => {
      setOpen(true);
      try {
        const response = await axios.post(`${BASE_URL}/getrealtimeinfo`, {
          login_id: login_id,
          dealer_code: dealer_code,
          usertype: 'DEALER',
        });
        setOpen(false);
        const dealerDetails = response.data.dealer_details;
        const unsettledBills = dealerDetails.transactiondetails || [];
        const openItems = dealerDetails.open_items || [];
        
        const totalAmount = openItems.reduce((sum, item) => {
          if (item.CRE_DEB_INDICATOR === "Debit") {
            return sum + parseFloat(item.AMOUNT || 0);
          }
          return sum; // Skip non-Debit items
        }, 0);
  

        setRealTime(dealerDetails);
        setUnsettledBills(openItems);
        setTotalOpenItemsAmount(totalAmount);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpen(false);
      }
    };
    fetchData();
  }, []);

  const handleClick = async () => {
    try {
      setOpen(true);


      const fromDate = formData.rundate[0].format('YYYY/MM/DD');
      const toDate = formData.rundate[1].format('YYYY/MM/DD');

      const response = await axios.post(`${BASE_URL}/getdealerdocumentdetails`, {
        login_id: login_id,
        dealer_code: dealer_code,
        from_date: fromDate,
        to_date: toDate,
        document_type: formData.selecttype,
      });


      setDocument(response.data);
      setIsDataAvailable(response.data && response.data.length > 0);

    } catch (error) {
      console.error('Error fetching data:', error);

      setIsDataAvailable(false);
    } finally {
      setOpen(false);
    }
  };



  const handleChange = (value, key) => {
    setFormData({
      ...formData,
      [key]: value
    });
    setIsDataAvailable(false);
  };

  const loadMore = () => {
    setDisplayedBills(displayedBills + 25);
  };

  const cardStyle = {
    color: 'white',
    border: '2px solid rgb(209, 208, 208)',
    padding: '10px',
    height: '90px',
    borderRadius: '20px',
    textAlign: 'center',
    background: 'linear-gradient(to right, rgb(10, 2, 48), #1793c6)'
  };


  const exportToExcel = () => {

    const dataToExport = unsettledBills.slice(0, displayedBills).map(bill => ({
      'Document Number': bill.DOCUMENT_NUMBER,
      'Posting Date': new Date(bill.POSTING_DATE).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).replace(/ /g, '-'),
      'Document Date': new Date(bill.DOCUMENT_DATE).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).replace(/ /g, '-'),
      'Advance': bill.ADVANCE,
      'Amount': bill.AMOUNT,
      'Cr Dr INR': bill.CRE_DEB_INDICATOR,
      'Reference': bill.REFERENCE,
      'Clearing Doc No': bill.CLEARING_DOC_NO,
      'Invoice Reference': bill.INVOICE_REFERENCE,
      'Document Type': bill.DOCUMENT_TYPE,
      'Description': bill.DESCRIPTION,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Unsettled Bills");

    XLSX.writeFile(workbook, 'UnsettledBills.xlsx');
  };


  return (
    <>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className='container'>
        <br />

        <h4 style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Real Time Info</h4>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography style={{ fontWeight: 'bold' }}>Balance Check</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div style={cardStyle}>
                    <Row>
                      <Col style={{ fontSize: '30px', textAlign: 'left', fontWeight: 600, }} span={12}>{new Intl.NumberFormat('en-IN').format(Closebalance)} </Col>
                      <Col style={{ textAlign: 'right' }} span={12}> <FaIndianRupeeSign style={{ fontSize: '25px' }} /> </Col>
                    </Row>
                    <Row>
                      <Col style={{ textAlign: 'left', fontWeight: 600, }} span={24}>Current Balance</Col>
                    </Row>
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <div style={cardStyle}>
                    <Row>
                      <Col style={{ fontSize: '30px', textAlign: 'left', fontWeight: 600, }} span={12}>{new Intl.NumberFormat('en-IN').format(advance)} </Col>
                      <Col style={{ textAlign: 'right' }} span={12}> <ProductOutlined style={{ fontSize: '25px' }} /> </Col>
                    </Row>
                    <Row>
                      <Col style={{ textAlign: 'left', fontWeight: 600, }} span={24}>MPO Advance</Col>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div style={cardStyle}>
                    <Row>
                      <Col style={{ fontSize: '30px', textAlign: 'left', fontWeight: 600, }} span={12}>{new Intl.NumberFormat('en-IN').format(totalOpenItemsAmount)}</Col>
                      <Col style={{ textAlign: 'right' }} span={12}> <TrophyOutlined style={{ fontSize: '25px' }} /> </Col>
                    </Row>
                    <Row>
                      <Col style={{ textAlign: 'left', fontWeight: 600, }} span={24}>Outstanding</Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <br />
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography style={{ fontWeight: 'bold' }}>Invoice & Credit/Debit Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <br />
              <Form variant="filled">
                <style>{styles}</style>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label="Run Date"
                      name="rundate"
                      rules={[
                        {
                          required: true,
                          message: 'Please select run date!',
                        },
                      ]}
                    >
                      <RangePicker format="DD/MM/YYYY" onChange={(dates) => handleChange(dates, 'rundate')} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>

                    <Form.Item
                      label="Select Type"
                      name="selecttype"
                      rules={[
                        {
                          required: true,
                          message: 'Please Select Type',
                        },
                      ]}
                    >
                      <div className="container form">
                        <label>
                          <input
                            type="radio"
                            value={'INV'}
                            checked={formData.selecttype === 'INV'}
                            onChange={() => handleChange('INV', 'selecttype')}
                          />
                          <span>Invoice</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            value={'CR/DR'}
                            checked={formData.selecttype === 'CR/DR'}
                            onChange={() => handleChange('CR/DR', 'selecttype')}
                          />
                          <span>Credit/Debit</span>
                        </label>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <button type="button" class="btn btn-primary" onClick={handleClick} style={{ cursor: 'pointer', border: 'none', borderRadius: '10px', width: '100%', height: 40 }}>
                      View
                    </button>
                  </Col>
                </Row>
              </Form>
              <br></br>
              <br></br>
              <>

                {isDataAvailable ? (
                  <Typography>
                    <div style={{ overflow: 'auto', maxHeight: '300px', border: '1px solid black', fontSize: '14px' }}>
                      <div style={{ minWidth: '1000px', width: '100%' }}>
                        <div style={{ borderBottom: '1px solid black', backgroundColor: '#C1F7FD', display: 'flex', position: 'sticky', top: '0', zIndex: '1' }}>
                         {formData.selecttype !== "INV" && (
  <div
    style={{
      flex: '3',
      textAlign: 'center',
      fontWeight: 'bold',
      borderRight: '1px solid black',
      minWidth: '100px',
      padding: '8px 4px'
    }}
  >
   DOCUMENT TYPE
  </div>
)}

                          <div style={{ flex: '3', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>{formData.selecttype === "INV" ? "INVOICE NUMBER" : "DOCUMENT NUMBER"}</div>
                          <div style={{ flex: '4', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>DATE</div>
                          <div style={{ flex: '4', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>{formData.selecttype === "INV" ? "ORDER NUMBER" : "REFERENECE NUMBER"}</div>
                          <div style={{ flex: '4', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>{formData.selecttype === "INV" ? "ORDER DATE" : "REFERENECE DATE"}</div>
                          <div style={{ flex: '4', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>NET VALUE</div>
                          <div style={{ flex: '5', textAlign: 'center', fontWeight: 'bold', padding: '8px 4px' }}>PDF</div>
                        </div>
                        <div style={{ overflowY: 'auto', marginTop: '0px' }}>
                          {document.map((item, index) => (
                            <div key={index} style={{ borderBottom: '1px solid black', display: 'flex' }}>
                               {formData.selecttype !== "INV" && ( <div style={{ flex: '3', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>{item.Document_Type}</div>)}
                              <div style={{ flex: '3', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>{item.Invoicenumber}</div>
                              <div style={{ flex: '4', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>
                                {new Date(item.Date).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                }).replace(/ /g, '-')}
                              </div>
                              <div
  style={{
    flex: '4',
    textAlign: 'center',
    borderRight: '1px solid black',
    minWidth: '100px',
    padding: '8px 4px'
  }}
>
  {formData.selecttype === "INV" ? item.DMSORDERNUMBER : item.Reference_No}
</div>

                              <div style={{ flex: '4', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>
                               {
  formData.selecttype === "INV"
    ? new Date(item.DMSORDERDATE).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).replace(/ /g, '-')
    : new Date(item.Reference_Date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).replace(/ /g, '-')
}

                             
                              </div>
                              <div style={{ flex: '4', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px', padding: '8px 4px' }}>{item.net_value}</div>
                              <div style={{ flex: '5', textAlign: 'center', padding: '8px 4px' }}>
                                <a href={`${BASE_URL.replace('/api', '')}/exports/${item.PDF}`} target="_blank" rel="noopener noreferrer">
                                  View PDF
                                </a>

                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Typography>
                ) : (
                  <Empty description="No Data Available" />
                )}

              </><br></br>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <br /><br />

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel2-header"
          >
            <Typography style={{ fontWeight: 'bold' }}>Unsettled Documents</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div style={{ textAlign: 'right' }}>
                <Button onClick={exportToExcel} style={{ marginBottom: '10px', padding: '5px 10px', cursor: 'pointer', color: 'white', background: 'green' }}>
                  Export to Excel
                </Button>
              </div>

              <div style={{ overflow: 'auto', maxHeight: '300px', border: '1px solid black', fontSize: '14px' }}>
                <div style={{ minWidth: '1500px', width: '100%' }}>

                  <div style={{ display: 'flex', backgroundColor: '#C1F7FD', position: 'sticky', top: '0', zIndex: '1', borderBottom: '1px solid black' }}>
                    <div style={{ flex: '2', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>DOCUMENT NUMBER</div>
                    <div style={{ flex: '2', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>POSTING DATE</div>
                    <div style={{ flex: '2', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>DOCUMENT DATE</div>
                    <div style={{ flex: '2', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>ADVANCE</div>
                    <div style={{ flex: '2', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>AMOUNT</div>
                    <div style={{ flex: '1', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>CR DR INR</div>
                    <div style={{ flex: '3', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>REFERENCE</div>
                    <div style={{ flex: '2', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>CLEARING DOC NO</div>
                    <div style={{ flex: '3', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>INVOICE REFERENCE</div>
                    <div style={{ flex: '2', textAlign: 'center', fontWeight: 'bold', borderRight: '1px solid black', minWidth: '100px' }}>DOCUMENT TYPE</div>
                    <div style={{ flex: '3', textAlign: 'center', fontWeight: 'bold', minWidth: '100px' }}>DESCRIPTION</div>
                  </div>


                  <div style={{ overflowY: 'auto', marginTop: '0px' }}>
                    {unsettledBills.slice(0, displayedBills).map((bill) => (
                      <div key={bill.DOCUMENT_NUMBER} style={{ display: 'flex', borderBottom: '1px solid black' }}>
                        <div style={{ flex: '2', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.DOCUMENT_NUMBER}</div>
                        <div style={{ flex: '2', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>
                          {new Date(bill.POSTING_DATE).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          }).replace(/ /g, '-')}

                        </div>

                        <div style={{ flex: '2', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>
                          {new Date(bill.DOCUMENT_DATE).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          }).replace(/ /g, '-')}

                        </div>
                        <div style={{ flex: '2', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.ADVANCE}</div>
                        <div style={{ flex: '2', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.AMOUNT}</div>
                        <div style={{ flex: '1', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.CRE_DEB_INDICATOR}</div>
                        <div style={{ flex: '3', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.REFERENCE}</div>
                        <div style={{ flex: '2', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.CLEARING_DOC_NO}</div>
                        <div style={{ flex: '3', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.INVOICE_REFERENCE}</div>
                        <div style={{ flex: '2', textAlign: 'center', borderRight: '1px solid black', minWidth: '100px' }}>{bill.DOCUMENT_TYPE}</div>
                        <div style={{ flex: '3', textAlign: 'center', minWidth: '100px' }}>{bill.DESCRIPTION}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Typography>


          </AccordionDetails>
        </Accordion>
      </div>

    </>
  );
}